module.exports = __webpack_public_path__ + "img/handwrite-seal.0c5d3a19.svg";